import * as Constants from "./constants";

export class StorageHelper {
    static setUser(user) {
        localStorage.setItem(Constants.LS_USER_KEY, JSON.stringify(user));
    }

    static getUser() {
        let user = localStorage.getItem(Constants.LS_USER_KEY);
        try {
            return JSON.parse(user);
        } catch (e) {
            console.error("error parsing user");
        }
    }

    // Duplicated these methods for backward compatibility
    static setUserConsumer(user) {
        localStorage.setItem(Constants.LS_USER_CONSUMER_KEY, JSON.stringify(user));
    }

    static getUserConsumer() {
        let user = localStorage.getItem(Constants.LS_USER_CONSUMER_KEY);
        try {
            return JSON.parse(user);
        } catch (e) {
            console.error("error parsing user");
        }
    }

    static removeUser() {
        localStorage.removeItem(Constants.LS_USER_KEY);
    }

    static setToken(token) {
        localStorage.setItem(Constants.LS_TOKEN_KEY, token);
    }

    static getToken() {
        return localStorage.getItem(Constants.LS_TOKEN_KEY);
    }

    static removeToken() {
        return localStorage.removeItem(Constants.LS_TOKEN_KEY);
    }


    static setTokenConsumer(token) {
        localStorage.setItem(Constants.LS_TOKEN_CONSUMER_KEY, token);
    }

    static getTokenConsumer() {
        return localStorage.getItem(Constants.LS_TOKEN_CONSUMER_KEY);
    }

    static removeTokenConsumer() {
        return localStorage.removeItem(Constants.LS_TOKEN_CONSUMER_KEY);
    }

    static getDefaultLanguage() {
        return localStorage.getItem(Constants.LS_DEFAULT_LANGUAGE_KEY)
    }
    static setDefaultLanguage(language) {
        localStorage.setItem(Constants.LS_DEFAULT_LANGUAGE_KEY, language);
    }

    static getDefaultCurrency() {
        return localStorage.getItem(Constants.LS_DEFAULT_CURRENCY_KEY)
    }
    static setDefaultCurrency(currency) {
        localStorage.setItem(Constants.LS_DEFAULT_CURRENCY_KEY, currency);
    }

    static getDefaultTimeZone() {
        return localStorage.getItem(Constants.LS_DEFAULT_TIMEZONE_KEY)
    }
    static setDefaultTimeZone(currency) {
        localStorage.setItem(Constants.LS_DEFAULT_TIMEZONE_KEY, currency);
    }

    static getDefaultCountryCode() {
        return localStorage.getItem(Constants.LS_DEFAULT_COUNTRY_CODE_KEY)
    }
    static setDefaultCountryCode(currency) {
        localStorage.setItem(Constants.LS_DEFAULT_COUNTRY_CODE_KEY, currency);
    }
}
